import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';

import BaseLayout from '../layouts/BaseLayout';
import ModalLayout from '../layouts/ModalLayout';
import WorksPage from '../pages/WorksPage';
import WorkPage from '../pages/WorkPage';
// import ServicesIndexPage from '../pages/ServicesIndexPage';
// import ServicesPage from '../pages/ServicesPage';
// import ServicePage from '../pages/ServicePage';
import ClientsIndexPage from '../pages/ClientsIndexPage';
import ClientsPage from '../pages/ClientsPage';
import ClientPage from '../pages/ClientPage';
import LocationsIndexPage from '../pages/LocationsIndexPage';
import LocationsPage from '../pages/LocationsPage';
import LocationPage from '../pages/LocationPage';
import DirectorsPage from '../pages/DirectorsPage';
import ContactsPage from '../pages/ContactsPage';
import NotFoundPage from '../pages/NotFoundPage';

class Routes extends React.PureComponent {
  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const background = location.state && location.state.background;

    if (location.pathname !== prevProps.location.pathname
      && !location.pathname.includes('/services/')
      && !location.pathname.includes('/clients/')
      && !location.pathname.includes('/locations/')
      && !background
    ) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { location } = this.props;
    const background = location.state && location.state.background;

    return (
      <>
        <BaseLayout>
          <Switch location={background || location}>
            <Route path="/" exact component={WorksPage} />
            {/* <CategoriesLayout path="/services">
              <Route path="/services" exact component={ServicesIndexPage} />
              <Route path="/services/:slug" exact component={ServicesPage} />
              <Route path="/services/:category/:slug" exact component={ServicePage} />
            </CategoriesLayout> */}
            <Route path="/clients" exact component={ClientsIndexPage} />
            <Route path="/clients/:slug" exact component={ClientsPage} />
            <Route path="/clients/:category/:slug" component={ClientPage} />
            <Route path="/locations" exact component={LocationsIndexPage} />
            <Route path="/locations/:slug" exact component={LocationsPage} />
            <Route path="/locations/:category/:slug" component={LocationPage} />
            <Route path="/directors" component={DirectorsPage} />
            <Route path="/contact" component={ContactsPage} />
            <Route path="/not-found" component={NotFoundPage} />
            <Route path="/:slug" component={WorkPage} />
          </Switch>
        </BaseLayout>

        {background && (
          <ModalLayout>
            <Route path="/locations/:category/:slug" component={LocationPage} />
            <Route path="/:slug" exact component={WorkPage} />
          </ModalLayout>
        )}
      </>
    );
  }
}

Routes.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    state: PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      background: PropTypes.object.isRequired,
    }),
  }).isRequired,
};

export default withRouter(Routes);
